import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hasUserConsented } from './CookieConsentBanner';
import { isPublicPath } from '../utils/publicPaths';
import { initGA4, trackPageView } from '../utils/analytics';

const Analytics: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const fire = () => {
      if (!hasUserConsented()) return;
      if (!isPublicPath(location.pathname)) return;
      initGA4();
      trackPageView(location.pathname);
    };

    fire();

    const handleGranted = () => fire();
    window.addEventListener('cookieConsentGranted', handleGranted);
    return () => window.removeEventListener('cookieConsentGranted', handleGranted);
  }, [location.pathname]);

  return null;
};

export default Analytics;
